import config from 'config';

const HEALTH_STATUS_UP = 'UP';

export const checkBackendHealth = async () => {
  try {
    const response = await fetch(`${config.BASE_API_URL}/health`, { method: 'GET' });

    if (!response.ok) {
      return false;
    }

    const body = await response.json();

    return body?.status === HEALTH_STATUS_UP;
  } catch (error) {
    return false;
  }
};
